import { useId } from 'react';
import type { SVGProps } from 'react';

export const ArenaCashWordmark = (props: SVGProps<SVGSVGElement>) => {
  const gradientId = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="108"
      height="25"
      viewBox="0 0 108 25"
      fill="none"
      {...props}
    >
      <path
        d="M21.6998 1.23242L21.9 2.2207L25.4996 19.957L28.6246 2.25195L28.8043 1.23242H44.276L44.6461 1.68555L47.4108 5.06836L47.7662 5.50293L47.6715 6.05762L46.5826 12.3809L46.5074 12.8213L46.1676 13.1104L44.5739 14.4668L44.3961 14.6191L44.1744 14.6943L42.8424 15.1504L42.944 15.3965L45.2643 21.0439L48.5807 2.25195L48.7604 1.23242H74.4537L74.7926 1.9209L77.8307 8.09375L78.11 8.66016L78.0846 8.70703L78.7301 10.0039L80.0895 2.25293L80.2682 1.23242H87.8326L87.5768 2.67969L84.5983 19.5537L94.4313 1.86719L94.7838 1.23242H101.899L102.099 2.2207L106.158 22.2207L106.459 23.6992H98.5143L98.3502 22.6582L97.9557 20.1689H94.1256L93.9987 19.0781L93.8444 17.749L93.818 17.8027L93.8151 17.7822L93.1149 19.165L93.1256 19.1699L92.5406 20.3213L91.1666 23.0244L90.8239 23.6992H77.7125L77.3737 23.0098L73.3571 14.8389L73.0651 14.2451L73.0826 14.2139L73.0221 14.0869L72.9977 14.2285L71.5182 22.6787L71.3405 23.6992H38.0563L37.7496 22.915L35.3502 16.7871H33.8453L32.818 22.6777L32.6393 23.6992H18.3151L18.151 22.6582L17.7574 20.1689H12.7145V19.4512L12.4772 19.918L12.5348 19.9424L11.9371 21.1162L10.9674 23.0244L10.6246 23.6992H2.09631L3.11487 21.8672L14.2321 1.86719L14.5846 1.23242H21.6998ZM55.1852 8.99805H64.943L64.6852 10.4463L63.8912 14.917L63.7106 15.9346H54.3004L54.0895 15.2998L53.9791 15.9346H53.9703L53.8619 16.5273H65.0406L66.4742 8.4043H55.2936L55.1852 8.99805ZM96.0748 13.3506H96.8297L96.65 12.2148L96.0748 13.3506ZM15.8756 13.3506H16.6315L16.4518 12.2139L15.8756 13.3506ZM35.1295 9.64453H39.1793L39.2867 9.55176L39.486 8.4043H35.3453L35.1295 9.64453Z"
        fill="#D857FF"
        stroke={`url(#${gradientId})`}
        strokeWidth="2.46587"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="104.95"
          y1="12.4658"
          x2="4.19202"
          y2="12.4658"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#500036" />
          <stop offset="1" stopColor="#1E1E1E" />
        </linearGradient>
      </defs>
    </svg>
  );
};
